import React from 'react';
import { Button, Checkbox, Input, InputNumber, Switch, Upload, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { AccountMetaData } from '../../../../config/settings';
import { getUploadApiBaseUrl } from '../../../../lib/apis';

function formatMoney(value) {
    if (typeof value === 'undefined' || value === null || value === '') return '';
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function parseMoney(value) {
    if (!value) return 0;
    return Number(`${value}`.replace(/,/g, '')) || 0;
}

function getVariantUploadFileList(variant = {}, index = 0) {
    if (Array.isArray(variant._imageFileList) && variant._imageFileList.length > 0) {
        return variant._imageFileList;
    }

    if (!variant.image) {
        return [];
    }

    return [{
        uid: `${variant._id || variant.sku || index}-image`,
        name: variant.name || variant.sku || 'variant-image',
        status: 'done',
        url: variant.image
    }];
}

export default function VariantListSection(props) {
    const { variants = [], onCreateVariant, onVariantChange, onRemoveVariant } = props;
    const uploadApiBaseUrl = getUploadApiBaseUrl();

    const handleImageUploadChange = (index, variant, info) => {
        const file = info && info.file ? info.file : null;
        if (!file) return;

        const nextFileList = (info.fileList || []).slice(-1).map((item) => ({
            uid: item.uid,
            name: item.name,
            status: item.status,
            url: item.url,
            thumbUrl: item.thumbUrl,
            response: item.response,
            percent: item.percent,
            originFileObj: item.originFileObj,
            error: item.error
        }));

        if (file.status === 'uploading') {
            onVariantChange(index, {
                ...variant,
                _imageUploading: true,
                _imageFileList: nextFileList
            });
            return;
        }

        if (file.status === 'done') {
            const uploadedUrl = file.response && file.response.attachment ? file.response.attachment.url : (file.url || '');
            onVariantChange(index, {
                ...variant,
                image: `${uploadedUrl || ''}`.trim(),
                _imageUploading: false,
                _imageFileList: nextFileList.map((item) => ({
                    ...item,
                    status: 'done',
                    url: uploadedUrl || item.url
                }))
            });
            return;
        }

        if (file.status === 'error') {
            onVariantChange(index, {
                ...variant,
                _imageUploading: false,
                _imageFileList: nextFileList
            });
            message.error(file.error && file.error.message ? file.error.message : 'Tải ảnh biến thể thất bại');
            return;
        }

        if (file.status === 'removed') {
            onVariantChange(index, {
                ...variant,
                image: '',
                _imageUploading: false,
                _imageFileList: []
            });
        }
    };

    return (
        <div style={{ marginBottom: 16, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff' }}>
            <style>{`
                .variant-image-upload--compact .ant-upload.ant-upload-select-picture-card,
                .variant-image-upload--compact .ant-upload-list-picture-card-container {
                    width: 60px;
                    height: 60px;
                    margin: 0;
                }

                .variant-image-upload--compact .ant-upload.ant-upload-select-picture-card {
                    background: #fafafa;
                    border-radius: 8px;
                }

                .variant-image-upload--compact .ant-upload-list-picture-card .ant-upload-list-item {
                    padding: 2px;
                    border-radius: 8px;
                }

                .variant-image-upload--compact .ant-upload-list-item-thumbnail img {
                    object-fit: cover;
                }

                .variant-image-upload--compact .ant-upload {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            `}</style>
            <div className="d-flex justify-content-between align-items-center" style={{ padding: '16px 16px 8px' }}>
                <div>
                    <div style={{ fontSize: 28, fontWeight: 700, marginBottom: 4 }}>Biến thể</div>
                    <div style={{ color: '#6b7280' }}>Danh sách biến thể của sản phẩm</div>
                </div>
                <Button onClick={onCreateVariant}>+ Biến thể</Button>
            </div>
            <div style={{ padding: '0 16px 16px' }}>
                <table className="table table-sm" style={{ marginBottom: 0 }}>
                    <thead>
                        <tr>
                            <th style={{ width: 40 }}><Checkbox /></th>
                            <th style={{ width: 84 }}>Ảnh</th>
                            <th style={{ width: 140 }}>Mã SKU</th>
                            <th style={{ width: 180 }}>Tên biến thể</th>
                            <th>Thuộc tính</th>
                            <th style={{ width: 130 }}>Mã vạch</th>
                            <th style={{ width: 140 }}>Giá bán</th>
                            <th style={{ width: 110 }}>Trọng lượng</th>
                            <th style={{ width: 110 }}>Trạng thái</th>
                            <th style={{ width: 60 }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {variants.length === 0 ? (
                            <tr>
                                <td colSpan="10" style={{ textAlign: 'center', color: '#9ca3af' }}>Chưa có variant</td>
                            </tr>
                        ) : variants.map((variant, index) => {
                            const attributesText = Object.keys(variant.attributes || {}).map((key) => `${variant.attributes[key]}`).join(', ');
                            const uploadFileList = getVariantUploadFileList(variant, index);
                            return (
                                <tr key={variant._id || variant.sku || index}>
                                    <td><Checkbox /></td>
                                    <td>
                                        <Upload
                                                className="variant-image-upload--compact"
                                                listType="picture-card"
                                                fileList={uploadFileList}
                                                action={`${uploadApiBaseUrl}/api/v1/uploads`}
                                                name="file"
                                                withCredentials={true}
                                                accept="image/*"
                                                headers={{
                                                    Authorization: AccountMetaData.getToken(),
                                                    Company: AccountMetaData.getCompanyId()
                                                }}
                                                onChange={(info) => handleImageUploadChange(index, variant, info)}
                                                onPreview={(file) => {
                                                    const previewUrl = (file.response && file.response.attachment && file.response.attachment.url) || file.url || file.thumbUrl;
                                                    if (previewUrl) {
                                                        window.open(previewUrl, '_blank');
                                                    }
                                                }}
                                            >
                                                {uploadFileList.length >= 1 ? null : (
                                                    <div style={{ fontSize: 11, lineHeight: 1.2 }}>
                                                        <PlusOutlined style={{ fontSize: 14 }} />
                                                        <div style={{ marginTop: 4 }}>Upload</div>
                                                    </div>
                                                )}
                                            </Upload>
                                    </td>
                                    <td>
                                        <Input value={variant.sku || ''} onChange={(e) => onVariantChange(index, { ...variant, sku: e.target.value })} />
                                    </td>
                                    <td>
                                        <Input value={variant.name || ''} onChange={(e) => onVariantChange(index, { ...variant, name: e.target.value })} />
                                    </td>
                                    <td>
                                        <Input value={attributesText} disabled />
                                    </td>
                                    <td>
                                        <Input value={variant.barcode || ''} onChange={(e) => onVariantChange(index, { ...variant, barcode: e.target.value })} />
                                    </td>
                                    <td>
                                        <InputNumber
                                            min={0}
                                            style={{ width: '100%' }}
                                            value={variant.sale_price || 0}
                                            formatter={(value) => formatMoney(value)}
                                            parser={(value) => parseMoney(value)}
                                            onChange={(value) => onVariantChange(index, { ...variant, sale_price: value || 0 })}
                                        />
                                    </td>
                                    <td>
                                        <InputNumber min={0} style={{ width: '100%' }} value={variant.shipping && variant.shipping.weight ? variant.shipping.weight : 0} onChange={(value) => onVariantChange(index, { ...variant, shipping: { ...(variant.shipping || {}), weight: value || 0 } })} />
                                    </td>
                                    <td>
                                        <Switch checked={variant.status === 'active'} onChange={(checked) => onVariantChange(index, { ...variant, status: checked ? 'active' : 'inactive' })} />
                                    </td>
                                    <td>
                                        <Button danger size="small" onClick={() => onRemoveVariant(index)}>Xóa</Button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
